import React from 'react';
import classNames from 'classnames';
import { v4 as uuid } from 'uuid';
import bowser from 'yola-bowser';
import Icon from '../icon';
import Tooltip from '../tooltip';
import { APPEARANCES, SIZES } from './constants';
import { IconButtonProps } from './types';

const IconButton = ({
  icon = null,
  glyph = 'icons',
  label = null,
  size = SIZES.extraLarge,
  appearance = APPEARANCES.light,
  transparent = null,
  selected = false,
  disabled = false,
  onClick = null,
  onMouseDown = null,
}) => {
  // The 'transparent' mode must be available as default
  // for 'small' and 'medium' sizes of the component
  const isTransparent = transparent || size === SIZES.small || size === SIZES.medium;

  const classes = classNames(
    `ws-ui-icon-button`,
    `ws-ui-icon-button--size-${size}`,
    `ws-ui-icon-button--appearance-${appearance}`,
    {
      'ws-ui-icon-button--transparent': isTransparent,
      'ws-ui-icon-button--selected': selected,
    }
  );

  const isTouchDevice = bowser.mobile || bowser.tablet;
  const isTooltipEnabled = !!label && !isTouchDevice;
  const tooltipId = `icon_button_${uuid()}`;
  const tooltipAttrsForButton = {
    'data-tip': true,
    'data-for': tooltipId,
  };

  return (
    <React.Fragment>
      <button
        onClick={onClick}
        onMouseDown={onMouseDown}
        disabled={disabled}
        className={classes}
        {...(isTooltipEnabled && tooltipAttrsForButton)}
      >
        {icon ? (
          <div className="ws-ui-icon-button__icon ws-ui-icon-button__icon--custom">{icon}</div>
        ) : (
          <div className="ws-ui-icon-button__icon">
            <Icon glyph={glyph} type="inherit" size="100%" />
          </div>
        )}
      </button>

      {isTooltipEnabled && <Tooltip id={tooltipId} text={label} />}
    </React.Fragment>
  );
};

IconButton.propTypes = IconButtonProps;

export default IconButton;
